import React, { useState } from "react";
import BergEventLED from "./BergEventLED";
import "./FullscreenDisplay.css";

const FullscreenDisplay = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const enterFullscreen = async () => {
    try {
      const elem = document.documentElement;

      if (elem.requestFullscreen) {
        await elem.requestFullscreen();
      } else if ((elem as any).webkitRequestFullscreen) {
        await (elem as any).webkitRequestFullscreen();
      } else if ((elem as any).msRequestFullscreen) {
        await (elem as any).msRequestFullscreen();
      }

      setIsFullscreen(true);
    } catch (err) {
      console.error("Nie można przejść do trybu pełnoekranowego:", err);
    }
  };

  return (
    <div className="fullscreen-container">
      <div className="led-display-wrapper">
        <BergEventLED />
      </div>

      {/* <div className="fullscreen-controls">
        {!isFullscreen ? (
          <button className="fullscreen-button" onClick={enterFullscreen}>
            Przejdź do trybu pełnoekranowego
          </button>
        ) : (
          <div className="exit-fullscreen-info">
            Naciśnij ESC, aby wyjść z trybu pełnoekranowego
          </div>
        )}
      </div> */}
    </div>
  );
};

export default FullscreenDisplay;

// import React, { useState, useEffect } from "react";
// import BergEventLED from "./BergEventLED";
// import "./FullscreenDisplay.css";

// const FullscreenDisplay = () => {
//   const [isFullscreen, setIsFullscreen] = useState(false);

//   // Sprawdzanie czy przeglądarka jest w trybie pełnoekranowym
//   useEffect(() => {
//     const checkFullscreen = () => {
//       const isInFullScreen = !!(
//         document.fullscreenElement ||
//         (document as any).webkitFullscreenElement ||
//         (document as any).mozFullScreenElement ||
//         (document as any).msFullscreenElement
//       );
//       setIsFullscreen(isInFullScreen);
//     };

//     // Nasłuchuj na zmiany stanu pełnoekranowego
//     document.addEventListener("fullscreenchange", checkFullscreen);
//     document.addEventListener("webkitfullscreenchange", checkFullscreen);
//     document.addEventListener("mozfullscreenchange", checkFullscreen);
//     document.addEventListener("MSFullscreenChange", checkFullscreen);

//     return () => {
//       document.removeEventListener("fullscreenchange", checkFullscreen);
//       document.removeEventListener("webkitfullscreenchange", checkFullscreen);
//       document.removeEventListener("mozfullscreenchange", checkFullscreen);
//       document.removeEventListener("MSFullscreenChange", checkFullscreen);
//     };
//   }, []);

//   // Funkcja do wejścia w tryb pełnoekranowy
//   const enterFullscreen = async () => {
//     try {
//       const elem = document.documentElement;

//       if (elem.requestFullscreen) {
//         await elem.requestFullscreen();
//       } else if ((elem as any).webkitRequestFullscreen) {
//         await (elem as any).webkitRequestFullscreen();
//       } else if ((elem as any).msRequestFullscreen) {
//         await (elem as any).msRequestFullscreen();
//       } else if ((elem as any).mozRequestFullScreen) {
//         await (elem as any).mozRequestFullScreen();
//       }
//     } catch (err) {
//       console.error("Nie można przejść do trybu pełnoekranowego:", err);
//     }
//   };

//   return (
//     <div className="auto-fullscreen-container">
//       <div className="led-display-wrapper">
//         <BergEventLED />
//       </div>

//       {!isFullscreen && (
//         <div className="fullscreen-overlay" onClick={enterFullscreen}>
//           <div className="big-fullscreen-button">
//             KLIKNIJ ABY PRZEJŚĆ DO TRYBU PEŁNOEKRANOWEGO
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FullscreenDisplay;
